// extracted by mini-css-extract-plugin
export default {"container":"vJ-z","error":"wJ-z","disabled":"xJ-z","submit":"yJ-z","option":"zJ-z","success":"AJ-z","failure":"BJ-z"};